<script>
import { Line } from 'vue-chartjs';
import * as chartFormatting from '@/data/chart-formatting.js';
import debounce from 'lodash/debounce';

const data = [
  [
    3096,
    3059,
    3161,
    3000,
    3419,
    3385,
    4263,
    5012,
    5669,
    6502,
    7626,
    8745,
    8377,
    8848,
    8587,
    7851,
    7536,
    7774,
    7915,
    8211,
    8453,
    8920,
    8417,
    8552,
    8971,
    10144,
    11883,
    13742,
    15085,
    15901,
    16278,
    15871,
    15537,
    15442,
    12888,
    11238,
    10935,
    10774,
    10285,
    9829,
    9667,
    9383,
    9043,
    9125
  ],
  [
    13670,
    12658,
    11998,
    10051,
    10181,
    9254,
    11224,
    12714,
    13835,
    15287,
    17735,
    19473,
    17864,
    18031,
    16492,
    14630,
    13647,
    13702,
    13587,
    13746,
    13696,
    14211,
    13197,
    13058,
    13249,
    14752,
    16880,
    19161,
    20370,
    20763,
    20729,
    19418,
    18992,
    18376,
    15110,
    12797,
    12239,
    11880,
    11256,
    10679,
    10289,
    9781,
    9250,
    9125
  ]
];
const datasetBorderColor = '#35ACD9';
const chartSpec = {
  labels: chartFormatting.xLabels,
  datasets: [
    {
      backgroundColor: '#512051',
      borderColor: datasetBorderColor,
      borderWidth: 1,
      data: data[0],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    },
    {
      backgroundColor: '#35ACD9',
      borderColor: datasetBorderColor,
      borderWidth: 1,
      data: data[1],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    }
  ]
};
const chartOptions = {
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 500
    }
  },
  animation: {
    easing: chartFormatting.animationEasing,
    duration: chartFormatting.animationDuration
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 20,
          autoSkip: true,
          beginAtZero: true,
          fontColor: '#424242',
          fontFamily: chartFormatting.labelFontFamily,
          fontSize: 14,
          lineHeight: 3,
          maxTicksLimit: 10,
          callback: function (val) { // Format the dollars on the Y-Axis
            if (val >= 1000000000) { // $x.xB
              return '$' + (val / 1000000000) + 'B';
            } else if (val >= 1000000) { // $x.xM
              return '$' + (val / 1000000) + 'M';
            } else { // $xx,xxx
              return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        },
        gridLines: {
          drawTicks: false,
          display: false
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          zeroLineColor: 'transparent'
        },
        ticks: chartFormatting.xLabelFormat
      }
    ]
  }
};

export default {
  name: 'PremiumsPerPhysicianChart',
  extends: Line,
  data: function () {
    return {
      chartOptions: chartOptions
    };
  },
  mounted () {
    this.resize();
    document.addEventListener('aos:in', this.aosChartEvent);
    this.handleDebouncedResize = debounce(this.resize, 100);
    window.addEventListener('resize', this.handleDebouncedResize);
  },
  beforeDestroy () {
    document.removeEventListener('aos:in', this.aosChartEvent);
    window.removeEventListener('resize', this.handleDebouncedResize);
  },
  methods: {
    aosChartEvent: function (event) {
      const eventDetail = (event.detail.detail !== undefined) ? event.detail.detail : event.detail;
      if (!eventDetail.classList.contains('chart-container-outer') ||
        !eventDetail.classList.contains('chart-container-premiums-per-physician')) return;
      document.removeEventListener('aos:in', this.aosChartEvent);
      this.render();
    },
    render: function () {
      this.renderChart(chartSpec, chartOptions);
    },
    resize: function () {
      /* eslint-disable */
      if ($(window).width() <= 400) {
        chartOptions.layout.padding.bottom = 120;
      } else if ($(window).width() >= 401 && $(window).width() < 500) {
        chartOptions.layout.padding.bottom = 180;
      } else if ($(window).width() >= 501 && $(window).width() < 600) {
        chartOptions.layout.padding.bottom = 250;
      } else if ($(window).width() >= 601 && $(window).width() < 749) {
        chartOptions.layout.padding.bottom = 300;
      } else if ($(window).width() >= 750 && $(window).width() < 999) {
        chartOptions.layout.padding.bottom = 400;
      } else if ($(window).width() >= 1000) {
        chartOptions.layout.padding.bottom = 500;
      }
      /* eslint-enable */
      this.render();
    }
  }
};
</script>
